import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const r = await register(form.name, form.email, form.password);
    setLoading(false);
    if (r.ok) { toast.success("Welcome to Pancham Dham"); navigate("/dashboard"); }
    else toast.error(r.error);
  };

  return (
    <div data-testid="register-page" className="min-h-[70vh] grid place-items-center px-4 py-14">
      <div className="w-full max-w-md bg-[#FFFDF9] sacred-border rounded-3xl p-10 relative om-watermark">
        <div className="overline">Create account</div>
        <h1 className="font-serif text-4xl text-[#4A0E17] mt-2">Begin your devotion</h1>
        <form onSubmit={submit} className="mt-7 space-y-4">
          <Input data-testid="register-name" required placeholder="Full name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="bg-white border-[#D4AF37]/40 h-12" />
          <Input data-testid="register-email" required type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="bg-white border-[#D4AF37]/40 h-12" />
          <Input data-testid="register-password" required type="password" placeholder="Password (6+ characters)" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="bg-white border-[#D4AF37]/40 h-12" />
          <Button data-testid="register-submit" type="submit" disabled={loading} className="w-full bg-[#4A0E17] hover:bg-[#36080F] rounded-full h-12 text-base">
            {loading ? "Creating account…" : "Create account"}
          </Button>
        </form>
        <p className="text-sm text-[#63534E] text-center mt-6">
          Already a devotee? <Link to="/login" className="text-[#E65100] font-semibold">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
